import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./EVESensitivityModelerGlobal.styles";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import EVESensitivityModelerGlobalFiltersAndReports from "./EVESensitivityModelerGlobalFiltersAndReports.component";
import { TreasuryKRISummaryProvider } from "../../../context/TreasuryKRISummaryContext";
import { ApprovalProvider } from "../../../context/ApprovalContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const EVESensitivityModelerGlobal = ({ toCompare = false } = {}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        <HedgeRatioProvider>
          <TreasuryKRISummaryProvider>
            <ApprovalProvider>
              <EVESensitivityModelerGlobalFiltersAndReports
                toSave={true}
                toCompare={toCompare}
                toDisableEntitySelection={false}
                reportLocated={"LEFT"}
              />
            </ApprovalProvider>
          </TreasuryKRISummaryProvider>
        </HedgeRatioProvider>
        {toCompare && (
          <HedgeRatioProvider>
            <TreasuryKRISummaryProvider>
              <ApprovalProvider>
                <EVESensitivityModelerGlobalFiltersAndReports
                  toSave={false}
                  toCompare={toCompare}
                  toDisableEntitySelection={true}
                  reportLocated={"RIGHT"}
                />
              </ApprovalProvider>
            </TreasuryKRISummaryProvider>
          </HedgeRatioProvider>
        )}
        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default EVESensitivityModelerGlobal;
